module.exports = __webpack_public_path__ + "resources/img/img-danbiAi-jp.74606c16c963f7171d30044d62cdfe9d.png";